<template>
    <div id="artists" v-if="!loading && !errorLoading">
        <div class="content">
            <h1 class="text-uppercase text-bold mt-5">Galeria de Artistas</h1>
            <p>
                O projeto nasceu em 2017 com o objetivo de construir uma galeria de talentos
                selecionados e convidados. Fizemos um trabalho de curadoria em busca de artistas que
                admiramos e que têm sinergia com os valores da Chico Rei, e montamos uma galeria com
                nomes incríveis. Ilustradores convidados trazem sua arte para nossa galeria e vendem
                seus produtos com nosso selo de qualidade. Confira!
            </p>
        </div>

        <div v-if="!isMobile">
            <h2 class="content text-uppercase text-bold mt-5">Artistas:</h2>
            <div class="artists-list">
                <div class="content">
                    <div
                        class="d-flex flex-column flex-wrap pt-4 pb-3"
                        :style="{ height: `${heightList}px` }"
                    >
                        <p v-for="artist in allArtists">
                            <a :href="artist.catalog_url">{{ artist.name }}</a>
                        </p>
                    </div>
                </div>
            </div>

            <div class="content mt-5">
                <!--  art-image-list-->
                <div class="d-inline-flex w-full">
                    <ul
                        class="product-list product-list-4 product-list-gap-x-2 product-list-gap-y-4"
                    >
                        <li v-for="artist in allArtists" class="">
                            <a :href="artist.catalog_url" class="text-no-decoration">
                                <img
                                    class="lazy lazy-fade img-responsive w-full"
                                    :alt="artist.products.data[0].name"
                                    :data-src="
                                        artist.products.data[0].img_thumb +
                                        '?auto=compress,format&q=65&w=312&h=312&fit=crop'
                                    "
                                />
                                <p class="text-uppercase">{{ artist.name }}</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="view-options">
                <button
                    class="btn btn-sm btn-light d-flex flex-justify-center flex-align-center mr-2"
                    :style="{ opacity: !viewBlock ? 0.3 : 1 }"
                    @click="viewBlock = true"
                >
                    <i class="icon-cr icon-block-view mb-2 mt-2"></i>
                </button>

                <button
                    class="btn btn-sm btn-light d-flex flex-justify-center flex-align-center"
                    :style="{ opacity: viewBlock ? 0.3 : 1 }"
                    @click="viewBlock = false"
                >
                    <i class="icon-cr icon-list-view mb-2 mt-2"></i>
                </button>
            </div>

            <div v-if="viewBlock" class="content pl-0">
                <ul class="product-list product-list-4 product-list-gap-x-2 product-list-gap-y-4">
                    <li v-for="artist in allArtists">
                        <a :href="artist.catalog_url">
                            <img
                                class="lazy lazy-fade img-responsive w-full"
                                :alt="artist.products.data[0].name"
                                :data-src="
                                    artist.products.data[0].img_thumb +
                                    '?auto=compress,format&q=65&w=312'
                                "
                                width="312"
                                height="234"
                            />
                            <p class="text-uppercase">{{ artist.name }}</p>
                        </a>
                    </li>
                </ul>
            </div>

            <div v-else class="content text-center">
                <div v-for="artist in allArtists" :key>
                    <a :href="artist.catalog_url" class="list-view">
                        <div class="d-flex flex-align-center text-center flex-item-grow">
                            <p class="text-uppercase ml-3">{{ artist.name }}</p>
                        </div>
                        <img
                            class="lazy lazy-fade img-cut"
                            :alt="artist.products.data[0].name"
                            :data-src="
                                artist.products.data[0].img_thumb +
                                '?auto=compress,format&q=65&w=250'
                            "
                        />
                    </a>
                </div>
            </div>
        </div>
    </div>
    <ErrorWarning v-else-if="errorLoading" />
</template>

<script>
    import ErrorWarning from '../common/ErrorWarning';
    import { partnerService } from '../../../../../submodules/src/service/resource';
    import {
        objectPropertyComparator,
        resizeOrientationAware,
        updateLazyLoad,
    } from '../../../../../submodules/src/script/common';
    import ProductGroup from '../product/ProductGroup';
    import ProductGroupList from '../product/ProductGroupList';
    import AnimatedHeader from '../common/AnimatedHeader';
    import AnimatedHeaderContent from '../common/AnimatedHeaderContent';
    import cr$ from '../../../../../submodules/src/script/crquery';

    export default {
        name: 'Artists',

        components: {
            AnimatedHeaderContent,
            ProductGroupList,
            ProductGroup,
            ErrorWarning,
            AnimatedHeader,
        },

        data() {
            return {
                allArtists: null,
                notPromotedArtists: null,
                promotedArtists: null,
                errorLoading: false,
                showFixedNavigation: false,
                heightList: null,
                isMobile: null,
                viewBlock: true,
                resizeAwareRemoveCb: null,
            };
        },

        mounted() {
            this.fetchArtists();
            this.resizeAwareRemoveCb = resizeOrientationAware(() => this.onResize(), true);
        },

        beforeDestroy() {
            this.resizeAwareRemoveCb();
        },

        watch: {
            allArtists: function () {
                this.$nextTick(function () {
                    updateLazyLoad();
                });
            },

            viewBlock: function () {
                this.$nextTick(function () {
                    updateLazyLoad();
                });
            },
        },

        computed: {
            loading() {
                return !this.notPromotedArtists || !this.promotedArtists;
            },
        },

        methods: {
            onResize() {
                this.isMobile = window.innerWidth < 768;
            },

            fetchArtists() {
                partnerService
                    .query({
                        partner_type_id: 2,
                        include: ['products'],
                    })
                    .then(this.handleResponse)
                    .catch(() => (this.errorLoading = true));
            },

            fetchArtsCount(artist) {
                partnerService
                    .countArts(artist.id)
                    .then((response) => this.$set(artist, 'artsCount', response.data));
            },

            handleResponse(response) {
                this.allArtists = response.data
                    .filter((a) => a.avatar && a.products && a.products.data.length > 0)
                    .sort(objectPropertyComparator('name'));

                this.notPromotedArtists = this.allArtists.filter((a) => !a.promoted);
                this.promotedArtists = this.allArtists.filter((a) => a.promoted);
                this.errorLoading = false;
                this.heightList = Math.ceil(this.allArtists ? this.allArtists.length / 4 : 0) * 32;

                for (const artist of this.promotedArtists) this.fetchArtsCount(artist);
            },
        },
    };
</script>
